export default function SolarPanel(props: any) {
    return (
        <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.934 40H39.3206C40.0062 40 40.4885 39.3257 40.2669 38.6769L33.9499 20.1769C33.8116 19.7721 33.4313 19.5 33.0035 19.5H9.61691C8.93127 19.5 8.449 20.1743 8.67056 20.8231L14.9876 39.3231C15.1259 39.7279 15.5062 40 15.934 40Z"
                stroke="white"
                strokeWidth="2"
            />
            <path d="M16.2188 40H11.0344C10.3731 40 9.89387 39.3696 10.0709 38.7324L12.2188 31" stroke="white" strokeWidth="2" />
            <path d="M34.2188 21L31.4025 12.5513C30.9942 11.3263 29.8478 10.5 28.5565 10.5L15.7188 10.5" stroke="white" strokeWidth="2" />
            <path d="M11.7188 29.5H37.2188" stroke="white" strokeWidth="2" />
            <path d="M17.2188 19.5L24.2188 40" stroke="white" strokeWidth="2" />
            <path d="M24.7188 19.5L31.7188 40" stroke="white" strokeWidth="2" />
            <path
                d="M13.6056 7.40583L9.49219 6.61816V7.84544V14.8L13.7359 13.8068C17.1761 13.0016 17.0757 8.07033 13.6056 7.40583Z"
                stroke="white"
                strokeWidth="1.63636"
            />
            <path
                d="M6.21875 8.25457C5.76688 8.25457 5.40057 8.62088 5.40057 9.07275C5.40057 9.52462 5.76688 9.89094 6.21875 9.89094V8.25457ZM6.21875 9.89094H9.49148V8.25457H6.21875V9.89094Z"
                fill="white"
            />
            <path
                d="M6.21875 11.5273C5.76688 11.5273 5.40057 11.8936 5.40057 12.3455C5.40057 12.7973 5.76688 13.1636 6.21875 13.1636V11.5273ZM6.21875 13.1636H9.49148V11.5273H6.21875V13.1636Z"
                fill="white"
            />
            <path d="M9.21875 5.80005L9.21875 15.6182" stroke="white" strokeWidth="1.63636" strokeLinecap="round" />
        </svg>
    );
}
